import React from 'react';
import './App.css';
import GetScholarships from "./getscholarships.js";

function App() {
  return (
    <div className="App">
      <GetScholarships />
    </div>
  );
}

export default App;
 